/*
 *  Filename........: magento1service.js
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 22.07.20, 08:24
 *  @author.........: Robin Rick
 *
 *  @brief..........:
 */

const magento1service = {
    get: function (id) {
        return axios.get('/api/v1/magento1connector/' + id).then(
            (response) => {
                return response.data.data;
            }
        );
    },
    getAll: function () {
        return axios.get('/api/v1/magento1connector/').then(
            (response) => {
                return response.data.data;
            }
        );
    },
    update: function (id, data) {
        return axios.post('/api/v1/magento1connector/' + id, data).then(
            (response) => {
                return response;
            }
        );
    },
    create: function (data) {
        return axios.post('/api/v1/magento1connector', data).then(
            (response) => {
                return response;
            }
        );
    },
    delete: function (id) {
        return axios.delete('/api/v1/magento1connector/' + id).then(
            (response) => {
                return response;
            }
        );
    }
}
export default magento1service;